module.exports = __webpack_public_path__ + "static/media/house-signal.72c9ef6c.svg";